import { Language, Lightning, Utils } from '@lightningjs/sdk'

export default class KeyboardButton extends Lightning.Component {
  static _template() {
    return {
      Background: {},
      Content: {},
    }
  }

  get c() {
    return this.key.c
  }

  set key(v) {
    this._key = v

    if (this.active) {
      this._update()
    }
  }

  get key() {
    return this._key
  }

  get isActive() {
    return this._keyActive
  }

  _init() {
    this._update()
  }

  _update() {
    const key = this._key,
      textContent = {
        fontFace: this.fontFace || 'OpenSansRegular',
        verticalAlign: 'middle',
        textAlign: 'center',
        fontSize: this.fontSize || 30,
        lineHeight: this.lineHeight || 40,
      },
      sizeContent = { w: this.w, h: this.h }

    let content = {}

    this._keyActive = true

    if (this._key.hasOwnProperty('keyBG')) {
      this.KeyBG = this._key.keyBG
    }

    if (this._key.hasOwnProperty('source')) {
      content = { ...sizeContent, src: this._key.source ? Utils.asset(this._key.source) : '' }
    } else if (this._key.hasOwnProperty('tsKey')) {
      let keyText = ''

      if (this._key.tsKey.includes('Keyboard')) {
        keyText = Language.translate(this._key.tsKey)
      } else {
        keyText = key.c
      }

      content = { text: { text: keyText, ...textContent } }
    } else if (this._key.hasOwnProperty('n')) {
      let keyText = key.n

      this._keyActive = false

      content = { alpha: 0.1, notActive: true, text: { text: keyText, ...textContent } }
    } else {
      content = { text: { text: key.c, ...textContent } }
    }

    this.patch({
      Background: {
        w: this.w,
        h: this.h,
        rect: true,
        color: 0xff1e47bc,
        shader: { type: lng.shaders.RoundedRectangle, stroke: 2, radius: 8 },
      },
      Content: { x: this.w / 2, y: this.h / 2, mountX: 0.5, mountY: 0.5, ...content },
    })
  }

  _focus() {
    this.patch({
      Background: {
        shader: { strokeColor: 0xffffffff },
      },
    })

    if (!this._key.hasOwnProperty('source')) {
      this.patch({
        Content: { text: { fontFace: 'OpenSansBold' } },
      })
    }
  }

  _unfocus() {
    this.patch({
      Background: {
        shader: { strokeColor: 0x00ffffff },
      },
    })

    if (!this._key.hasOwnProperty('source')) {
      this.patch({
        Content: { text: { fontFace: 'OpenSansRegular' } },
      })
    }
  }
}
